





























































import { mapGetters } from 'vuex';
import PaidFeatureNotEnabled from '@/common/components/PaidFeatureNotEnabled.vue';
import api from '@/common/api';
import PageLoader from '@/common/components/PageLoader.vue';
import PageHeader from '@/common/components/PageHeader.vue';
import LoadingModal from '@/common/components/LoadingModal.vue';
import Vue from 'vue';
import getSubdomain from '@/common/context';
import { JsonApiArrayResponse, JsonApiSingleResponse } from '@/jsonApi.types';
import InvoiceFeeModal from '@/common/components/modals/InvoiceFeeModal.vue';
import { CustomField, CustomFieldFillable } from '@/common/components/support/support.types';
import initCustomFields from '@/common/types/invoice.types';
import { reformatCustomFields } from '@/common/util/payments.util';
import { isEnabled } from 'vue-feature-flipping';
import { Feature } from '@/features.types';
import LineItem from '../line-items/LineItem.vue';
import { initLineItem, LineItemInterface, LineItemsInterface } from '../line-items/lineItems.types';
import InvoiceMerchantContact from './InvoiceMerchantContact.vue';
import InvoiceCustomerForm from './InvoiceCustomerForm.vue';
import InvoiceInformation from './InvoiceInformation.vue';
import InvoiceTotals from './InvoiceTotals.vue';
import {
  FeeType, InvoiceCustomer, MerchantInfo, InvoiceInformationInterface, initInvoiceInformation,
  SaveOption, formatDate, SaveText,
} from './invoices.types';
import AddLineItemButton from './AddLineItemButton.vue';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: 'Edit Invoice',
      config: {
        customFields: initCustomFields(),
      },
      isSubmitting: false as boolean,
      lineItem: initLineItem() as LineItemInterface,
      lineItems: [initLineItem() as LineItemInterface] as LineItemsInterface[],
      subtotal: 0 as number,
      merchantInfo: {} as MerchantInfo,
      invoiceCustomer: {} as InvoiceCustomer,
      addModal: false,
      discountPercent: 0 as number,
      customFields: [] as CustomFieldFillable[],
      taxPercent: 0 as number,
      shippingDollarAmount: 0 as number,
      invoiceInformation: initInvoiceInformation() as InvoiceInformationInterface,
      modalType: '' as string,
      editModal: false,
      showErrorMsg: false,
      saveOption: '',
      countries: [],
      states: [],
      loadingText: '' as string,
      sendCopyToMe: false as boolean,
    };
  },
  mounted() {
    api
      .get(`merchants/${getSubdomain()}/virtual-terminal`).then(this.setMerchant)
      .catch(() => {
        if (this.$refs.loader) {
          (this.$refs.loader as any).setError();
        }
      });
    api
      .get(`merchant/invoice/${this.id}`).then(this.setInvoice)
      .catch(() => {
        if (this.$refs.loader) {
          (this.$refs.loader as any).setError();
        }
      });
    api.get('countries').then(({ data: { data: countries } }) => {
      this.countries = countries;
    });
    api.get('states').then(({ data: { data: states } }) => {
      this.states = states;
    });
    this.getCustomFields();
  },
  methods: {
    addBlankLineItem() {
      this.lineItems.push(initLineItem());
    },
    addFilledLineItem(lineItem: LineItemInterface, id: number) {
      this.lineItems.splice(id, 1, lineItem);
      this.calculateSubtotal();
    },
    setInvoice({ data }: { data: JsonApiSingleResponse<any> }) {
      this.invoiceCustomer = { ...data.data.invoiceCustomer };
      const modifiedLineItems = data.data.lineItems.map((lineItem: LineItemInterface) => ({
        ...lineItem,
        rate: (lineItem.rate / 100).toFixed(2),
        lineTotal: lineItem.lineTotal / 100,
      }));
      this.lineItems = modifiedLineItems;
      this.invoiceInformation = { ...data.data.invoiceInformation };
      this.discountPercent = data.data.invoiceInformation.discount;
      this.taxPercent = data.data.invoiceInformation.tax;
      this.shippingDollarAmount = data.data.invoiceInformation.shipping;
      if (isEnabled(Feature.CUSTOM_FIELDS) && typeof data.data.customFields !== 'undefined') {
        this.customFields = data.data.customFields;
        this.assignCustomFields();
      }
    },
    setMerchant({ data }: { data: JsonApiSingleResponse<MerchantInfo> }) {
      this.merchantInfo = { ...data.data! };
      (this.$refs.loader as any).setReady();
    },
    save(sendImmediately = false) {
      this.saveOption = '';
      if (!this.isValid()) {
        return;
      }
      if (sendImmediately) {
        this.loadingText = SaveText.UPDATEANDSEND;
      } else {
        this.loadingText = SaveText.UPDATE;
      }
      this.submitActions(true);
      const modifiedLineItems = this.lineItems.map((lineItem) => ({
        ...lineItem,
        rate: lineItem.rate * 100,
      }));
      api
        .put(`/merchant/invoice/${this.id}`, {
          customer: { ...this.invoiceCustomer },
          customFields: reformatCustomFields(this.config.customFields),
          lineItems: { ...modifiedLineItems },
          invoiceInformation: { ...this.invoiceInformation },
          sendImmediately,
          sendCopyToMe: this.sendCopyToMe,
        })
        .then(this.showSuccess)
        .catch(this.handleSaveError);
    },
    showSuccess() {
      this.submitActions(false);
      if (this.loadingText === SaveText.UPDATE) {
        this.$toasted.success('Invoice updated successfully!');
      } else {
        this.$toasted.success('Invoice updated and sent successfully!');
      }
      this.$router.replace({ name: 'merchant.invoices.index' });
    },
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    handleSaveError({ response }: { response: any }) {
      this.submitActions(false);
      if (response.status === 422) {
        const errors = response?.data?.errors;
        let msg: any = '';
        Object.keys(errors).forEach((key: any, idx: any) => {
          if (idx > 0) msg += '<br />';
          msg += `${errors[key]}`;
        });
        this.$toasted.error(msg);
      } else {
        this.$toasted.error(`There was a problem creating the merchant. (${response.status})`);
      }
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
    deleteLineItem(id: number) {
      this.lineItems.splice(id, 1);
      this.calculateSubtotal();
    },
    calculateSubtotal() {
      const inital = 0;
      const subtotal = this.lineItems.reduce(
        (previousValue:number, item:LineItemInterface) => previousValue + item.lineTotal,
        inital,
      );
      this.subtotal = subtotal;
    },
    saveValue(value: number, modalType: string) {
      this.addModal = false;
      switch (modalType) {
        case FeeType.DISCOUNT:
          this.discountPercent = value;
          this.invoiceInformation.discount = this.discountPercent;
          this.initialDiscountState = false;
          break;
        case FeeType.TAX:
          this.taxPercent = value;
          this.invoiceInformation.tax = this.taxPercent;
          this.initialTaxState = false;
          break;
        default:
          this.shippingDollarAmount = value * 100;
          this.invoiceInformation.shipping = this.shippingDollarAmount;
          this.initialShippingState = false;
          break;
      }
    },
    openModal(modalType: string) {
      this.addModal = true;
      switch (modalType) {
        case FeeType.DISCOUNT:
          this.modalType = modalType;
          if (this.discountPercent > 0) {
            this.editModal = true;
          } else {
            this.editModal = false;
          }
          break;
        case FeeType.TAX:
          this.modalType = modalType;
          if (this.taxPercent > 0) {
            this.editModal = true;
          } else {
            this.editModal = false;
          }
          break;
        default:
          this.modalType = modalType;
          if (this.shippingDollarAmount > 0) {
            this.editModal = true;
          } else {
            this.editModal = false;
          }
          this.addModal = true;
          break;
      }
    },
    formatDate,
    getCustomFields() {
      api
        .get('/custom-fields', {
          params: {
            invoice: true,
          },
        })
        .then(this.setCustomFields);
    },
    setCustomFields({ data }: { data: JsonApiArrayResponse<CustomField> }) {
      this.config.customFields = data.data!.map((customField) => ({
        ...customField, value: '',
      }));
      this.assignCustomFields();
    },
    assignCustomFields() {
      if (typeof this.config.customFields !== 'undefined'
        && typeof this.customFields !== 'undefined'
        && this.customFields
        && this.config.customFields
        && this.config.customFields.length > 0
        && this.customFields.length > 0) {
        this.config.customFields = this.config.customFields.map((customField) => ({
          ...customField,
          value: this.findCustomFieldValueById(customField.id),
        }));
      }
    },
    findCustomFieldValueById(fieldId: string) {
      if (fieldId.length === 0) return '';
      const found = this.customFields.find(({ id }) => id === fieldId);
      return found?.value ?? '';
    },
  },
  watch: {
    saveOption() {
      if (this.saveOption === SaveOption.UPDATE) {
        this.save();
      } else if (this.saveOption === SaveOption.UPDATEANDSEND) {
        this.save(true);
      }
    },
  },
  computed: {
    ...mapGetters(['isInvoicingEnabled']),
    discountAmount(): number {
      return (this.subtotal * this.discountPercent) / 100;
    },
    taxAmount(): number {
      return ((this.subtotal - this.discountAmount) * this.taxPercent) / 100;
    },
    total(): number {
      return (this.subtotal - this.discountAmount) + this.taxAmount + this.shippingDollarAmount;
    },
    addOrEditModal(): string {
      return !this.editModal ? 'Add' : 'Edit';
    },
    initialDiscountState: {
      get(): boolean {
        return !(this.discountPercent > 0);
      },
      set() {
      },
    },
    initialTaxState: {
      get(): boolean {
        return !(this.taxPercent > 0);
      },
      set() {
      },
    },
    initialShippingState: {
      get(): boolean {
        return !(this.shippingDollarAmount > 0);
      },
      set() {
      },
    },
    saveOptions() {
      return [
        { value: SaveOption.UPDATE, display: 'Update' },
        { value: SaveOption.UPDATEANDSEND, display: 'Update and Send' },
      ];
    },
    showCustomFields(): boolean {
      return isEnabled(Feature.CUSTOM_FIELDS);
    },
  },
  components: {
    PageHeader,
    PageLoader,
    LineItem,
    InvoiceMerchantContact,
    InvoiceCustomerForm,
    InvoiceFeeModal,
    InvoiceInformation,
    InvoiceTotals,
    AddLineItemButton,
    LoadingModal,
    PaidFeatureNotEnabled,
  },
});
